import React, { useState } from "react";
import './Comment.css';

const Comments = ({ children }) => {
  return (
    <ul className="comments">
        {children}
    </ul>
  );
};

export default Comments;
